'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { Box, HStack, Button, Text, Input } from '@chakra-ui/react';
import { BoxTitle } from '@/components/BoxTitle';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaFormaPagamento({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newFormaPagamento, setNewFormaPagamento] = useState('');

  // Estados para o ModalRetorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  // Função para excluir os registros selecionados e atualizar o estado local
  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno("Forma de pagamento excluída com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  // Função para adicionar uma nova forma de pagamento
  const handleAddFormaPagamento = () => {
    if (newFormaPagamento.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, formaPagamento: newFormaPagamento, ativo: true },
      ]);
      setNewFormaPagamento('');
      setIsModalOpen(false);
      setMensagemRetorno("Forma de pagamento adicionada com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Text fontSize="lg" ml={2}>Adicionar Forma de Pagamento</Text>}
        body={
          <Box mt={3}>
            <BoxTitle title="Forma de Pagamento">
              <Input
                placeholder="Adicione uma forma de pagamento"
                value={newFormaPagamento}
                onChange={(e) => setNewFormaPagamento(e.target.value)}
              />
            </BoxTitle>
          </Box>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAddFormaPagamento}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
